import "./style.less";
export default function acceptTerms() {
    return {
        restrict: "E",
        scope: {
            termAccepted: "=",
            mustApproveDialog: "=",
        },
        template: require("./template.html"),
        controller: function ($scope, siteService, TermsModalFactory) {
            $scope.terms = null;

            $scope.toggleAcceptTerms = function () {
                $scope.termAccepted = !$scope.termAccepted; // ? false : true;

                if ($scope.termAccepted) {
                    $scope.mustApproveDialog = false;
                }
            };

            $scope.openTermsModal = () => {
                siteService.getTerms().then(function (terms) {
                    TermsModalFactory.modal(terms);
                });
            };
        },
    };
}
